import WebsiteSVG from "@design-system/ui-icons/vanilla/Website"
import { createIcon } from "../createIcon"

export const WebsiteIcon = createIcon(WebsiteSVG)
